<template>
  <div class="error" data-element="Error">
    <div class="error-content">
      <h2 v-if="title" class="error-content__title">{{ title }}</h2>
      <p v-if="description" class="error-content__description">{{ description }}</p>
      <div v-if="link" class="error-content__link">
        <ElementsButton tag="NuxtLinkLocale" :to="link.href || '/'">
          {{ link.title }}
        </ElementsButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    title?: string
    description?: string
    link?: {
      href?: string
      title?: string
    }
  }>()
</script>

<style lang="scss" scoped>
  .error {
    @apply flex flex-col items-center justify-center text-center py-20 px-4;

    &-content {
      @apply max-w-2xl mx-auto;

      &__title {
        @apply font-display uppercase font-semibold mb-6;
        font-size: 60px;
        color: #000;
        letter-spacing: 0.05em;
        line-height: 1.1;
      }
      &__description {
        @apply text-xl/relaxed mb-10;
        color: #555;
      }
      &__link {
        @apply flex justify-center;
      }
    }

    @include media("lg") {
      &-content {
        &__title {
          font-size: 60px;
        }
        &__description {
          @apply text-lg;
        }
      }
    }
    @include media("md") {
      &-content {
        &__title {
          font-size: 40px;
        }
        &__description {
          @apply text-base;
        }
      }
    }
  }
</style>
